var map = {
	"./fonts/icomoon": 70,
	"./fonts/icomoon.eot": 112,
	"./fonts/icomoon.svg": 70,
	"./fonts/icomoon.ttf": 113,
	"./fonts/icomoon.woff": 114,
	"./style": 71,
	"./style.css": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;